//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件
import {
  NavBar,
  Cell,
  CellGroup,
  Form,
  Field,
  Button,
  Icon,
  Tag,
  Popup,
  Picker,
  DatetimePicker,
  Toast
} from 'vant'
// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）
import 'vant/es/nav-bar/style'
import 'vant/es/cell/style'
import 'vant/es/cell-group/style'
import 'vant/es/form/style'
import 'vant/es/field/style'
import 'vant/es/button/style'
import 'vant/es/icon/style'
import 'vant/es/tag/style'
import 'vant/es/popup/style'
import 'vant/es/picker/style'
import 'vant/es/datetime-picker/style'
import 'vant/es/toast/style'
import 'vant/es/loading/style'

export default {
  name: 'maternal_special_meal_vant',
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker
  },
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data() {
    // 获取当天日期，格式：YYYY-MM-DD
    const today = new Date()
    const year = today.getFullYear()
    let month = today.getMonth() + 1
    month = month < 10 ? ('0' + month) : month
    let day = today.getDate()
    day = day < 10 ? ('0' + day) : day
    const todayDate = year + '-' + month + '-' + day

    return {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,
      
      tag: '',
      tagDisplayName: '',
      showTagPicker: false,
      
      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [
        { value: '1', label: '关注' },
        { value: '2', label: '提醒' },
        { value: '3', label: '紧急' },
        { value: '4', label: '特急' }
      ],
      
      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,
      
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',
      
      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,
      
      positions: [],
      position: '',
      positionDisplayName: '',
      showPositionPicker: false,
      
      agents: [],
      agent: '',
      agentSelectDisplayName: '',
      showAgentSelectPicker: false,
      
      selectDpId: '',
      selectPsId: '',
      selectAgId: '',
      selectAgent: []
    }
  },
  computed: {
    // 汇报人选择器数据格式转换
    agentColumns() {
      return this.agent_list.map(item => ({
        text: item.value || item.user_name,
        value: item.key || item.id
      }))
    },
    // 特殊标签选择器数据格式转换
    tagColumns() {
      return this.tag_List.map(item => ({
        text: item.value || item.name,
        value: item.key || item.id
      }))
    },
    // 部门选择器数据格式转换
    departmentColumns() {
      return this.departments.map(item => ({
        text: item.value || item.name,
        value: item.key || item.id
      }))
    },
    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex() {
      if (!this.department_id) {
        return 0
      }
      const index = this.departments.findIndex(item => {
        const itemValue = item.key || item.id
        console.log('itemValue', itemValue)
        return String(itemValue) === String(this.department_id)
      })
      return index === -1 ? 0 : index
    },
    // 职位选择器数据格式转换
    positionColumns() {
      return this.positions.map(item => ({
        text: item.value || item.name,
        value: item.key || item.id
      }))
    },
    // 员工选择器数据格式转换
    agentSelectColumns() {
      return this.agents.map(item => ({
        text: item.value || item.user_name,
        value: item.key || item.id
      }))
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    async fetchUserInfo() {
      try {
        const id = this.$cookie.get('id')
        if (!id) {
          return
        }
        // 通过 @store 的 userInfo 工具生成接口 URL
        const url = this.$store.$userInfo.getUserInfoUrl({
          id: id,
          key: this.$cookie.get('token')
        })
        const res = await this.$http.get(url)
        // 后端约定：{ errcode: 1, data: { ...用户信息... } }
        const body = res && res.data ? res.data : res
        if (body && body.errcode === 1 && body.data) {
          const user = body.data
          // 根据返回结构按需保存到本页面（这里先用到 department_id）
          if (user.department_id) {
            this.department_id = user.department_id
          }
          // 如有需要，可在此扩展更多字段
        }
      } catch (e) {
        console.error('fetchUserInfo error:', e)
      }
    },
    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),
    
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId() {
      const orderTotalId = this.$route.query.order_total_id
      if (!orderTotalId) {
        return ''
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        const ids = orderTotalId.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id))
        if (ids.length > 0) {
          return Math.max(...ids).toString()
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId
    },
    
    // 日期选择确认
    onDateConfirm(value) {
      const date = new Date(value)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? ('0' + month) : month
      let day = date.getDate()
      day = day < 10 ? ('0' + day) : day
      this.date = year + '-' + month + '-' + day
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false
    },
    
    // 汇报人选择确认
    onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      const agentId = (value && typeof value === 'object' && !Array.isArray(value))
        ? value.value
        : value
      
      if (!agentId) {
        this.showAgentPicker = false
        return
      }
      
      // 设置汇报人ID和显示名称
      this.agent_id = agentId
      
      // 查找显示名称
      const selected = this.agent_list.find(item => {
        const itemValue = item.key || item.id
        return String(itemValue) === String(agentId)
      })
      this.agentDisplayName = selected
        ? (selected.value || selected.user_name)
        : (this.agentColumns[index] && this.agentColumns[index].text || '')
      
      this.showAgentPicker = false
    },
    
    // 特殊标签选择确认
    onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      const tagId = (value && typeof value === 'object' && !Array.isArray(value))
        ? value.value
        : value
      
      if (!tagId) {
        this.showTagPicker = false
        return
      }
      
      // 设置特殊标签ID和显示名称
      this.tag = tagId
      
      // 查找显示名称
      const selected = this.tag_List.find(item => {
        const itemValue = item.key || item.id
        return String(itemValue) === String(tagId)
      })
      this.tagDisplayName = selected
        ? (selected.value || selected.name)
        : (this.tagColumns[index] && this.tagColumns[index].text || '')
      
      this.showTagPicker = false
    },
    
    // 部门选择确认
    onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      const departmentId = (value && typeof value === 'object' && !Array.isArray(value)) 
        ? value.value 
        : value
      
      if (!departmentId) {
        Toast.fail('请选择有效的部门')
        this.showDepartmentPicker = false
        return
      }
      
      // 设置部门ID和显示名称
      this.selectDpId = departmentId
      
      // 查找显示名称
      const selected = this.departments.find(item => {
        const itemValue = item.key || item.id
        return String(itemValue) === String(departmentId)
      })
      this.departmentDisplayName = selected 
        ? (selected.value || selected.name)
        : (this.departmentColumns[index] && this.departmentColumns[index].text || '')
      
      // 清空职位和员工选择
      this.selectPsId = ''
      this.positionDisplayName = ''
      this.selectAgId = ''
      this.agentSelectDisplayName = ''
      this.positions = []
      this.agents = []
      
      // 加载职位列表
      this.apiPostionList(this.selectDpId)
      this.showDepartmentPicker = false
    },
    
    // 职位选择确认
    onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      const positionId = (value && typeof value === 'object' && !Array.isArray(value))
        ? value.value
        : value
      
      if (!positionId) {
        this.showPositionPicker = false
        return
      }
      
      // 设置职位ID和显示名称
      this.selectPsId = positionId
      
      // 查找显示名称
      const selected = this.positions.find(item => {
        const itemValue = item.key || item.id
        return String(itemValue) === String(positionId)
      })
      this.positionDisplayName = selected
        ? (selected.value || selected.name)
        : (this.positionColumns[index] && this.positionColumns[index].text || '')
      
      // 清空员工选择
      this.selectAgId = ''
      this.agentSelectDisplayName = ''
      this.agents = []
      
      // 加载员工列表
      this.apiAgentList()
      this.showPositionPicker = false
    },
    
    // 员工选择确认
    onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      const agentId = (value && typeof value === 'object' && !Array.isArray(value))
        ? value.value
        : value
      
      if (!agentId) {
        this.showAgentSelectPicker = false
        return
      }
      
      // 设置员工ID和显示名称
      this.selectAgId = agentId
      
      // 查找显示名称
      const selected = this.agents.find(item => {
        const itemValue = item.key || item.id
        return String(itemValue) === String(agentId)
      })
      this.agentSelectDisplayName = selected
        ? (selected.value || selected.user_name)
        : (this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '')
      
      this.showAgentSelectPicker = false
    },
    
    // 表单提交处理
    onSubmit() {
      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在')
        Toast.fail('表单初始化失败')
        return
      }
      
      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(() => {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        this.submitForm()
      }).catch((err) => {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err)
        Toast('请完善表单信息')
      })
    },
    
    // 实际提交表单数据的方法
    submitForm() {
      // Vant 2.x 使用 Toast.loading() 显示加载提示
      Toast.loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      })
      
      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(agent => agent.id) // 上报给（不在 Form Field 中）
      }
      console.log('params', params)
      Api.otherFormApi.specialReportAddMeal(params).then(res => {
        console.log('res', res)
        // 关闭加载提示
        Toast.clear()

        if (res.errcode == 1) {
          Toast.success('提交成功')

          setTimeout(() => {
            this.goBack()
          }, 1000)
        } else {
          Toast.fail(res.errinfo || '提交失败')
        }
      }).catch(err => {
        console.error('API 请求失败:', err)
        // 关闭加载提示
        Toast.clear()
        // 显示详细的错误信息
        let errorMsg = '提交失败'
        if (err.response) {
          // 服务器返回了响应
          errorMsg = `提交失败: ${err.response.status} ${err.response.statusText}`
          console.error('Response data:', err.response.data)
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接'
          console.error('Request:', err.request)
        } else {
          // 其他错误
          errorMsg = `提交失败: ${err.message}`
        }
        Toast.fail(errorMsg)
      })
    },
    
    apiSpecialReportMeal() {
      // Vant 2.x 使用 Toast.loading() 显示加载提示
      Toast.loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      })
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      }
      Api.otherFormApi.getSpecialReportMeal(params).then(res => {
        console.log('res', res)
        if (res.errcode == 1) {
          this.tag_List = []
          this.agent_list = []

          this.agent_list = res.data.agent_list
          this.tag_List = res.data.tag_List

          this.tag_List.forEach(element => {
            element.key = element.id
            element.value = element.name
          })
          this.agent_list.forEach(element => {
            element.key = element.id
            element.value = element.user_name
          })
          
          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (this.agent_id) {
            const currentAgent = this.agent_list.find(item => {
              const itemValue = item.key || item.id
              return String(itemValue) === String(this.agent_id)
            })
            if (currentAgent) {
              this.agentDisplayName = currentAgent.value || currentAgent.user_name
            }
          }
          
          // 关闭加载提示
        Toast.clear()
        } else {
          // 关闭加载提示
        Toast.clear()
          Toast.fail(res.errinfo || '加载失败')
        }
      }).catch(err => {
        // 关闭加载提示
        Toast.clear()
        Toast.fail('加载失败')
        console.error('API 请求失败:', err)
      })
    },
    
    apiDeportment() {
      var params = {
        token: this.$cookie.get('token')
      }
      Api.otherFormApi.getDepartmentList(params).then(res => {
        console.log('res', res)
        if (res.errcode == 1) {
          this.departments = res.data
          this.departments.forEach(element => {
            element.key = element.id
            element.value = element.name
          })
          // 关闭加载提示
        Toast.clear()
        } else {
          // 关闭加载提示
        Toast.clear()
          Toast.fail(res.errinfo || '加载失败')
        }
      }).catch(err => {
        // 关闭加载提示
        Toast.clear()
        Toast.fail('加载失败')
        console.error('API 请求失败:', err)
      })
    },

    apiAgentList() {
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      }
      Api.otherFormApi.getAgentList(params).then(res => {
        console.log('res', res)
        if (res.errcode == 1) {
          this.agents = res.data
          this.agents.forEach(element => {
            element.key = element.id
            element.value = element.user_name
          })
          // 关闭加载提示
        Toast.clear()
        } else {
          // 关闭加载提示
        Toast.clear()
          Toast.fail(res.errinfo || '加载失败')
        }
      }).catch(err => {
        // 关闭加载提示
        Toast.clear()
        Toast.fail('加载失败')
        console.error('API 请求失败:', err)
      })
    },

    apiPostionList(department_id) {
      // 确保 department_id 是原始值，不是响应式对象
      const deptId = (department_id && typeof department_id === 'object' && !Array.isArray(department_id))
        ? department_id.value
        : department_id
      
      if (!deptId) {
        Toast.fail('部门ID不能为空')
        return
      }
      
      Toast.loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      })
      
      const params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      }
      
      Api.otherFormApi.getPositionList(params).then(res => {
        Toast.clear()
        if (res.errcode == 1) {
          this.positions = res.data || []
          this.positions.forEach(element => {
            element.key = element.id
            element.value = element.name
          })
        } else {
          Toast.fail(res.errinfo || '加载职位列表失败')
        }
      }).catch(err => {
        Toast.clear()
        let errorMsg = '加载职位列表失败'
        if (err.response) {
          errorMsg = err.response.status === 404 
            ? '职位列表接口不存在(404)，请检查API配置'
            : `加载失败: ${err.response.status} ${err.response.statusText}`
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接'
        }
        Toast.fail(errorMsg)
        console.error('职位列表API请求失败:', err)
      })
    },

    showChageAgent() {
      this.showChangeAgentPanel = true
    },
    
    dialog_cancel() {
      this.showChangeAgentPanel = false
      // 重置选择状态
      this.selectDpId = ''
      this.departmentDisplayName = ''
      this.selectPsId = ''
      this.positionDisplayName = ''
      this.selectAgId = ''
      this.agentSelectDisplayName = ''
      this.positions = []
      this.agents = []
    },
    
    goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      })
    },
    
    dialog_confirm() {
      if (!this.selectAgId) {
        Toast('请选择员工')
        return
      }
      
      const selectAg = this.agents.find(agent => agent.id === this.selectAgId)
      if (!selectAg) {
        Toast('员工信息不存在')
        return
      }
      
      // 检查是否已添加
      const exists = this.selectAgent.find(agent => agent.id === this.selectAgId)
      if (exists) {
        Toast('该员工已添加')
        return
      }
      
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      })
      console.log('选择了员工', this.selectAgent)
      
      // 关闭面板并重置选择
      this.dialog_cancel()
    },
    
    removeAgent(agentId) {
      console.log('删除', agentId)
      const index = this.selectAgent.findIndex(agent => agent.id === agentId)
      if (index !== -1) {
        this.selectAgent.splice(index, 1)
      }
    }
  },
  created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    const currentUserId = this.$cookie.get('id')
    if (currentUserId) {
      this.agent_id = currentUserId
    }
      // 页面打开时请求 userInfo
    this.fetchUserInfo() 
    this.apiSpecialReportMeal()
    this.apiDeportment()
  }
}



// WEBPACK FOOTER //
// ./src/componentsVant/ssReport/maternal_special_meal.vue